import { useStore } from "../store";

const PLAN_HIERARCHY = ["Free", "Mini", "Starter", "Professional", "Enterprise"];

const PLAN_LIMITS = {
  Free:          { products: 1000,    users: 3,   suppliers: 0   },
  Mini:          { products: 1000,    users: 3,   suppliers: 0   },
  Starter:       { products: 10000,   users: 3,   suppliers: 50  },
  Professional:  { products: 100000,  users: 10,  suppliers: 250 },
  Enterprise:    { products: Infinity, users: Infinity, suppliers: Infinity },
};

/**
 * Hook for checking the current tenant's plan and feature access.
 *
 * Usage:
 *   const { plan, canCreateSchemas, productLimit } = usePlan();
 */
export function usePlan() {
  const tenantProfile = useStore((s) => s.tenantProfile);
  const plan = tenantProfile?.plan || "Free";
  const planIndex = Math.max(0, PLAN_HIERARCHY.indexOf(plan));
  const limits = PLAN_LIMITS[plan] || PLAN_LIMITS.Free;

  return {
    plan,
    planIndex,

    // Tier checks
    isFree: planIndex <= 0,
    isStarter: planIndex >= 2,
    isProfessional: planIndex >= 3,
    isEnterprise: planIndex >= 4,

    // Feature flags (match backend FacetFluxPlanLimitationsService:
    // any paid plan gets Starter features, Professional+ gets pro features)
    canCreateSchemas: planIndex >= 1,
    canUseSmartImport: planIndex >= 1,
    canAccessApi: planIndex >= 1,
    canShareSchemas: planIndex >= 1,
    canBulkExport: planIndex >= 1,
    canAdvancedMapping: planIndex >= 3,
    canFullApi: planIndex >= 3,

    // Numeric limits
    productLimit: limits.products,
    userLimit: limits.users,
    supplierLimit: limits.suppliers,
  };
}
